import { render, staticRenderFns } from "./BreakdownVsAvailability.vue?vue&type=template&id=351d10b5"
import script from "./BreakdownVsAvailability.vue?vue&type=script&lang=js"
export * from "./BreakdownVsAvailability.vue?vue&type=script&lang=js"
import style0 from "./BreakdownVsAvailability.vue?vue&type=style&index=0&id=351d10b5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports